module.exports = {"API_KEY":"rhuqy2pzwssnkp3ne39pq8fxzgrcd6gz"}


//////////////////
// WEBPACK FOOTER
// ./src/config/local.json
// module id = 797
// module chunks = 0